module.exports = __webpack_public_path__ + "static/media/bnb.9a7adfde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/bnb.svg
// module id = 849
// module chunks = 7